
const jwt = require('jsonwebtoken');

module.exports = (function() {

   function verifyToken(token, key) {
      // JCB: marche aléatoirement sur le serveur avec RS256 PUBLIC_KEY/PRIVATE_KEY
      //return jwt.verify(token, key, 'RS256')
      return jwt.verify(token, "MYSECRET", 'HS256')
   }

   // should never be used
   function decodeToken(token) {
      return jwt.decode(token)
   }

   return {
      verifyToken: verifyToken,
      decodeToken: decodeToken,
   };

})()



// WEBPACK FOOTER //
// ./src/utilities/jwtToken.js